import axios from 'axios';
import authHeaders from './auth-header';
import router from '@/router';

const mapWindow: any = window;
const mapConfig: any = mapWindow.appConfig || {};
const mapApiURL: string = mapConfig.API_URL;

const API_URL = process.env.API_URL || mapApiURL || 'http://localhost:4000/api/v1';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.request.use((request) => {
  const token = authHeaders();

  if ( token != null ) {
    request.headers.Authorization = token;
  }

  return request;
}, (error) => {
  return Promise.reject(error);
});

http.interceptors.response.use((response) => {
 return response;
}, (error) => {
 if (error.response.status === 401) {
   localStorage.removeItem('jwt');
   router.push('/login');
 }
 return error;
});

export default http;
